import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./auth/msalConfig";
import { AccessProvider } from "./context/AccessContext";

const msalInstance = new PublicClientApplication(msalConfig);

window.msalInstance = msalInstance;

const root = ReactDOM.createRoot(document.getElementById("root"));

async function startApp() {
  try {
     // 🚨 BLOCK iframe execution
    if (window !== window.parent && !window.opener) {
      console.warn("MSAL iframe detected → skipping app load");
      return;
    }
    
    await msalInstance.initialize();

    const response = await msalInstance.handleRedirectPromise();

    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }

    console.log("Active Account:", msalInstance.getActiveAccount());

  } catch (err) {
    console.error("MSAL init error:", err);
  }

  root.render(
    <MsalProvider instance={msalInstance}>
      <AccessProvider>
        <App />
      </AccessProvider>
    </MsalProvider>
  );
}

startApp();